import BN from "bn.js";
import { PublicKey } from "@solana/web3.js";
import { UnstakeAccount } from "../type";

export interface IUnstakeWrapper {
  getUnstakeAccount(): UnstakeAccount;
  getOwner(): PublicKey;
  getEscrowAddress(): PublicKey;
  getStakingAddress(): PublicKey;

  getAmount(): BN;
  getUiAmount(): number;

  getWithdrawableTimestamp(): number;
  canWithdraw(currentTimestamp: number): boolean;
  getTimeUntilWithdrawable(currentTimestamp: number): number;
}

export class UnstakeWrapper implements IUnstakeWrapper {
  public unstakeAccount: UnstakeAccount;
  public tokenDecimals: number;
  private multiplier: number;

  constructor(unstakeAccount: UnstakeAccount, tokenDecimals: number) {
    this.unstakeAccount = unstakeAccount;
    this.tokenDecimals = tokenDecimals;
    this.multiplier = 10 ** tokenDecimals;
  }

  getUnstakeAccount(): UnstakeAccount {
    return this.unstakeAccount;
  }

  getOwner(): PublicKey {
    return this.unstakeAccount.owner;
  }

  getEscrowAddress(): PublicKey {
    return this.unstakeAccount.escrow;
  }

  getStakingAddress(): PublicKey {
    return this.unstakeAccount.staking;
  }

  getAmount(): BN {
    return this.unstakeAccount.amount;
  }

  getUiAmount(): number {
    return this.unstakeAccount.amount.toNumber() / this.multiplier;
  }

  getWithdrawableTimestamp(): number {
    return this.unstakeAccount.withdrawableTimestamp.toNumber();
  }

  canWithdraw(currentTimestamp: number): boolean {
    return currentTimestamp >= this.getWithdrawableTimestamp();
  }

  getTimeUntilWithdrawable(currentTimestamp: number): number {
    const remaining = this.getWithdrawableTimestamp() - currentTimestamp;
    return remaining > 0 ? remaining : 0;
  }
}
